<div class="mt-0 mb-3">
    <dp-table [table]="table" [customStyles]="{'cssClass':'table table-hover'}" (selectedRow)="onChangeCheck()"
        [selectable]="true" [showLoading]="showLoading">
    </dp-table>
</div>
<dp-pagination [hidden]="getElements() === 0" style="display: flex; flex-direction: column"
    (newPageSize)="onChangePageSize($event)" (newPage)="onChangePage($event)" [pageSizes]="[25, 50, 100]"
    [page]="getCurrentPage()" [elements]="getElements()">
</dp-pagination>